import { useEffect, useEffectEvent } from 'react';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { playableBlockchainRarities } from '@sorare/core/src/lib/cards';
import { PillSwitchRarity } from '@sorare/marketplace/src/atoms/PillSwitchRarity';
import { useMarketHomeFilters } from '@sorare/marketplace/src/hooks/useMarketHomeFilters';

const FloatingBar = styled(Horizontal).attrs({ center: true })`
  padding: var(--double-unit) 0;
`;

export const SelectNewSeasonRarity = () => {
  const { currentUser } = useCurrentUserContext();
  const { marketHomeFilters, updateRarity } = useMarketHomeFilters();

  const { rarity } = marketHomeFilters;

  // `common` isn't a pill on this bar, so a stored `common` would leave it
  // unselected. Reset to `limited` on landing.
  const autoSelectLimitedOnLanding = useEffectEvent(() => {
    if (rarity === Rarity.common) {
      updateRarity(Rarity.limited);
    }
  });
  useEffect(() => {
    autoSelectLimitedOnLanding();
  }, []);

  if (!currentUser) {
    return null;
  }

  return (
    <Portal id="above-bottom-bar-portal">
      <FloatingBar>
        <PillSwitchRarity
          rarities={[...playableBlockchainRarities]}
          selectedRarity={rarity}
          onChange={updateRarity}
        />
      </FloatingBar>
    </Portal>
  );
};
